module.exports = __webpack_public_path__ + "img/Monaco.7648117b.svg";